import styled from 'styled-components';
import { TABLET_BREAKPOINT_IN_PX } from '../../constants';

const Title = styled.div`
  margin-bottom: 20px;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    margin-bottom: 10px;
  }
`;

export default Title;
